import { isTerminalStatus } from './workflow-utils';

export function computeWorkflowRefetchInterval(status: string | null | undefined): number | false {
  if (status && isTerminalStatus(status)) {
    return false;
  }
  return 3000;
}
